import type { LockerverseAuction } from "./auction-types.ts";

const MEDIA_PREFIX = "https://media.lockerverse.com/";

export function rewriteAuctionMedia(
  auction: LockerverseAuction,
  mediaBaseUrl: string | undefined
): LockerverseAuction {
  if (mediaBaseUrl === undefined) {
    return auction;
  }
  // Keep the explicit proxy identity with the snapshot, including across SSR.
  auction.mediaBaseUrl = mediaBaseUrl;
  const rewrite = <Value extends string | null | undefined>(value: Value) =>
    value?.startsWith(MEDIA_PREFIX)
      ? `${mediaBaseUrl}/${value.slice(MEDIA_PREFIX.length)}`
      : value;

  auction.configuration.image = rewrite(auction.configuration.image);
  if (auction.community) {
    auction.community.banner = rewrite(auction.community.banner);
    auction.community.thumbnail = rewrite(auction.community.thumbnail);
  }
  for (const item of auction.items) {
    item.image = rewrite(item.image);
    item.images = item.images.map(rewrite);
  }
  return auction;
}
